<script>
import Zetrix from "../../utils/zetrix";
import ButtonPlain from "../../components/buttons/buttonPlain.vue";
import bgImage from "@/assets/images/Background.png";
import zetrixLogo from "@/assets/images/Logo.svg";
import QrCode from "@/assets/images/connect-wallet.png";

export default {
  name: "MainPageLogin",
  components: {
    ButtonPlain,
  },
  mixins: [Zetrix],
  data() {
    return {
      backgroundImage: bgImage,
       qrCode: QrCode,
        zLogo: zetrixLogo,
    };
  },
  computed: {
    isSmallScreen() {
      return this.$vuetify.display.xs;
    },
  },
  methods: {
    customProcess() {
      this.checkZetrixInstall();
    },
    connectMobile(){
      this.connectViaMobile();
    },
    closeSnackbar() {
      this.$store.dispatch("hideSnackbar");
    },
  },
};
</script>

<template>
  <v-container fluid class=" pa-0">
    <v-row class="main-login-layout">
      <!-- LEFT COLUMN: Background Image and Text -->
      <v-col
        cols="12"
        md="6"
        class="d-flex flex-column text-left left-column"
        :style="`background: url(${backgroundImage}) no-repeat center center; background-size: cover;`"
      >
        <div class="pa-10">
          <!-- <h3 class="text-h2 font-weight-bold text-white mb-10">ZETRIX</h3> -->
           <img :src="zLogo" alt="Logo" class="brand-logo mb-10" />
          <h3 class="issue-text mb-4">
            Issue. Manage. Verify.
          </h3>
          <p class="empower-text">
            Empower your organization to issue and manage Verifiable Credentials
            with confidence and ease.
          </p>
        </div>
      </v-col>

      <!-- RIGHT COLUMN: Login Form -->
      <v-col
        cols="12"
        md="6"
        class="d-flex align-center justify-center pa-4"
      >
        <div class="auth-wrapper override-auth-wrapper d-flex align-center justify-center pa-4">
          <v-card class="auth-card pa-4 pt-7" max-width="500">
            <v-card-text class="pt-2 text-center">
            <!-- Header -->
            <p class="text-h4 font-weight-bold mb-4">Connect with QR Code</p>
            <p class="text-body-1 font-weight-normal mb-8">Scan with your Zetrix Wallet app.</p>

            <!-- QR Code -->
            <!-- <v-row class="justify-center mb-10">
                <v-img
                :src="qrCode"
                alt="QR Code"
                max-width="200"
                max-height="200"
                class="rounded-lg elevation-1"
                contain
                />
            </v-row> -->
             <v-btn
                class="custom-btn mb-4"
                block
                large
                   @click="connectMobile"
                >
                   Connect via Zetrix Mobile Wallet
            </v-btn>


         

            <!-- Divider with OR -->
            <v-row align="center" justify="center" class="mb-4">
              <v-col cols="5">
                <v-divider />
              </v-col>

              <v-col cols="2" class="text-center grey--text font-weight-medium">
                OR
              </v-col>

              <v-col cols="5">
                <v-divider />
              </v-col>
            </v-row>


            <!-- Chrome Extension Button -->
            <v-btn
                class="custom-btn mb-4"
                block
                large
                   @click="customProcess"
                >
                Connect with Chrome Extension
            </v-btn>

            </v-card-text>

          </v-card>

        </div>
        
      </v-col>
    </v-row>
  </v-container>
    <v-snackbar
    v-model="$store.state.snackbarVisible"
    color="#feeced"
    location="top right"
    timeout="-1"
  >
    {{ $store.state.snackbarMessage }}

    <template v-slot:actions>
      <v-btn color="red" variant="text" @click="closeSnackbar"> CLOSE </v-btn>
    </template>
  </v-snackbar>
</template>

<style scoped>
/* .main-login-layout {
  min-height: 100vh;
} */

.left-column {
  color: white;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.7);
}

.left-column h3.issue-text {
  font-family: 'Gilroy', sans-serif;
  font-weight: 700;
  font-style: normal;
  font-size: 60px;
  line-height: 70px;
  letter-spacing: 0%;
  color: white;
  margin-bottom: 24px;
}

.empower-text {
  font-family: 'Gilroy', sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 20px;
  line-height: 30px;
  letter-spacing: 0%;
  color: white;
  margin-top: 16px;
  max-width: 650px;
}



.auth-wrapper.override-auth-wrapper {
  height: 90vh !important;
  min-block-size: auto !important;
  overflow: hidden !important;
}

.custom-btn {
  color: white;
  width: 304px;
  height: 48px;
  border-radius: 30px;
  padding: 12px 24px;
  background: linear-gradient(180deg, #DC404D 0%, #C22328 99.99%, #C22328 100%);
  text-transform: none; /* keep original casing */
  font-family: Gilroy, sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0;
}
</style>
